module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAANlBMVEUAAADOzDz////OzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzOzDzmBuXzAAAAEXRSTlMAAAARIjNEVWZ3iJmqu8zd7qKQ+8MAAADqSURBVCjPndNLksMgDEVRiY9AJtjc/W+2BxAn6dg96DejTlECIUT0PaXv3WNYEflQA2CP19qhA+1SEzSNO8QrrVA1VLArbZA0GJQLzYNDNZRLTQOKamiQv3WHpqoRcPf8qQ26qqoz84hBRDSbmZnDiOvOMz2IyPZcYbNfZmZWdjARObHOCqtPGbaXetIPDdBfeh59YQG/1Tgg3e/tEP6pabDfawG/V/tTH2BL+5caHGGqawGLv9SXljmpx5ZPdbClYztW8WMrlkKYzxmCiEwZdRu8p87ZyK333rKq1sdpR7n4C2rV3d2f8/wD8LgVmeJQpWAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_tl_icon_like_active.png
// module id = 759
// module chunks = 0